export default __webpack_public_path__ + "static/media/Lauren 9781846161698.0c0a6c06.jpg";